import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClose,
  faAnglesRight,
  faAnglesDown,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import PopUpWindowChat from "../../chat/PopUpWindowChat";
import { hasArea } from "ol/size";
import ShowSlider from "../../mainLayer/hazardIncidentsLayers/ReportIncidentsShowSlider";


interface Props {
  w_id: string | number;
  w_name: string| number;
  w_status: string| number;
  adm3_en: string| number;
  issued_time: string| number;
  w_desc: string| number;
  adm4_en: string| number;
  bwater_level: string| number;
  end_time: string| number;
  hwater_level: string| number;
  img_url: string| number;
  imp_communication: string| number;
  imp_electricity: string| number;
  imp_house: string| number;
  imp_human: string| number;
  imp_response: string| number;
  imp_roadblock: string| number;
  imp_roaddamage: string| number;
  imp_water: string| number;
  impdes_communication: string| number;
  impdes_electricity: string| number;
  impdes_house: string| number;
  impdes_human: string| number;
  impdes_roadblock: string| number;
  impdes_roaddamage: string| number;
  impdes_water: string| number;
  occurance_date: string| number;
  observed_date: string| number;
  tp_number: string| number;
}

const SumMainHz: React.FC<Props> = ({  w_id,
    adm4_en,
    bwater_level,
    end_time,
    hwater_level,
    img_url,
    imp_communication,
    imp_electricity,
    imp_house,
    imp_human,
    imp_response,
    imp_roadblock,
    imp_roaddamage,
    imp_water,
    impdes_communication,
    impdes_electricity,
    impdes_house,
    impdes_human,
    impdes_roadblock,
    impdes_roaddamage,
    impdes_water,
    issued_time,
    occurance_date,
    observed_date,
    tp_number,
    w_desc,
    w_name,
 }) => {

    const [wId, setWId] = useState<string>("");
    const [imgUrl, setImgUrl] = useState<string>("");
    const [selectTab, setSelectTab] = useState<string>("popupTabDetails");

    useEffect(() => {
        setWId(String(w_id));
      }, [w_id]);

      useEffect(() => {
      }, [wId]);
    
      useEffect(() => {
        setImgUrl(String(img_url)); // Convert w_id to string
      }, [img_url]);

      useEffect(() => {
      }, [imgUrl]);

  return (
    <div

    style={{
      width: "100%",
      height: "50vh",
      cursor: "move",
      touchAction: "none",
    }}
  >
    <div className="Mainpopup">
    <div className="popup">
      <div className="popupBoxContainer">
        {/* Popup title container */}

     
        {/* Popup tab data containers */}
        <section className="tabsDataContainer">
          {/* Details tab data */}
          <div
            className={`tabDataContainer detailsTabContainer ${
              selectTab === "popupTabDetails" ? "tabOpen" : ""
            }`}
          >
            {/* Left side */}
            <div className="detailsTabContainerLeft">
              {/* Details container */}
              <div className="detailsContainer">
                <span className="title">{w_name}</span>
                <div className="dataContainer">
                  <div className="dataRow">
                    <span className="name">Description</span>
                    <span className="data">{w_desc}</span>
                  </div>
                  <div className="dataRow">
                    <span className="name">
                      
                      Grama Niladari Devision
                    </span>
                    <span className="data"> {adm4_en}</span>
                  </div>
                  <div className="dataRow">
                    <span className="name">Date</span>
                    <span className="data">{issued_time}</span>
                  </div>
                  <div className="dataRow">
                    <span className="name"> Occurrence date</span>
                    <span className="data">{occurance_date}</span>
                  </div>
                  <div className="dataRow">
                    <span className="name">Observed date</span>
                    <span className="data">{observed_date}</span>
                  </div>
                  <div className="dataRow">
                    <span className="name">Telephone number</span>
                    <span className="data">{tp_number}</span>
                  </div>
                  <div className="dataRow">
                    <span className="name"> People affected</span>
                    <span className="data">{imp_human}</span>
                  </div>
                  {impdes_human && (
                    <div className="dataRow">
                      <span className="name">More description</span>
                      <span className="data">{impdes_human}</span>
                    </div>
                  )}

                  <div className="dataRow">
                    <span className="name">House damaged</span>
                    <span className="data">{imp_house}</span>
                  </div>
                  {impdes_house && (
                    <div className="dataRow">
                      <span className="name">More description</span>
                      <span className="data">{impdes_house}</span>
                    </div>
                  )}
                  <div className="dataRow">
                    <span className="name">Road blocks</span>
                    <span className="data">{imp_roadblock}</span>
                  </div>
                  {impdes_roadblock && (
                    <div className="dataRow">
                      <span className="name">More description</span>
                      <span className="data">
                        {impdes_roadblock}
                      </span>
                    </div>
                  )}
                  <div className="dataRow">
                    <span className="name">Road damages</span>
                    <span className="data"> {imp_roaddamage}</span>
                  </div>
                  {impdes_roaddamage && (
                    <div className="dataRow">
                      <span className="name">More description</span>
                      <span className="data">
                        {impdes_roaddamage}
                      </span>
                    </div>
                  )}
                  <div className="dataRow">
                    <span className="name">
                      Electricity supply failure
                    </span>
                    <span className="data">{imp_electricity}</span>
                  </div>
                  {impdes_electricity && (
                    <div className="dataRow">
                      <span className="name">More description</span>
                      <span className="data">
                        {impdes_electricity}
                      </span>
                    </div>
                  )}
                  <div className="dataRow">
                    <span className="name">
                      Water supply failure
                    </span>
                    <span className="data">{imp_water}</span>
                  </div>
                  {impdes_water && (
                    <div className="dataRow">
                      <span className="name">More description</span>
                      <span className="data">{impdes_water}</span>
                    </div>
                  )}
                  <div className="dataRow">
                    <span className="name">
                      
                      Communication supply failure
                    </span>
                    <span className="data">
                      
                      {imp_communication}
                    </span>
                  </div>
                  {impdes_communication && (
                    <div className="dataRow">
                      <span className="name">More description</span>
                      <span className="data">
                        {impdes_communication}
                      </span>
                    </div>
                  )}
                  
                </div>
              </div>
              {/* Comment section */}
              <div className="commentContainer">
                <span className="title">{w_name}</span>
                <PopUpWindowChat w_id={wId} />
              
              </div>
            </div>
            <div className="detailsTabContainerRight">
            <ShowSlider img_url={imgUrl} w_id={wId} />
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
  </div>
    // <div className={`popup`}>

    //   <div className={`incident-wrapper`}>
    //     <div
    //       className={`tabDataContainer detailsTabContainer tabOpen
    //       `}
    //     >
    //       <div className="detailsTabContainerLeft">
    //         <div className="detailsContainer">
    //           <div className="dataContainer">
    //             <div className="dataRow">
    //               <span className="name">Description</span>
    //               <span className="data">{w_desc}</span>
    //             </div>
    //             <div className="dataRow">
    //               <span className="name">Grama Niladari Devision</span>
    //               <span className="data"> {adm4_en}</span>
    //             </div>
    //             <div className="dataRow">
    //               <span className="name">Date</span>
    //               <span className="data">{issued_time}</span>
    //             </div>
    //             <div className="dataRow">
    //               <span className="name"> Occurrence date</span>
    //               <span className="data">{occurance_date}</span>
    //             </div>
    //             <div className="dataRow">
    //               <span className="name">Observed date</span>
    //               <span className="data">{observed_date}</span>
    //             </div>
    //             <div className="dataRow">
    //               <span className="name">Telephone number</span>
    //               <span className="data">{tp_number}</span>
    //             </div>
    //             <div className="dataRow">
    //               <span className="name"> People affected</span>
    //               <span className="data">{imp_human}</span>
    //             </div>
    //             {impdes_human && (
    //               <div className="dataRow">
    //                 <span className="name">More description</span>
    //                 <span className="data">{impdes_human}</span>
    //               </div>
    //             )}

    //             <div className="dataRow">
    //               <span className="name">House damaged</span>
    //               <span className="data">{imp_house}</span>
    //             </div>
    //             {impdes_house && (
    //               <div className="dataRow">
    //                 <span className="name">More description</span>
    //                 <span className="data">{impdes_house}</span>
    //               </div>
    //             )}
    //             <div className="dataRow">
    //               <span className="name">Road blocks</span>
    //               <span className="data">{imp_roadblock}</span>
    //             </div>
    //             {impdes_roadblock && (
    //               <div className="dataRow">
    //                 <span className="name">More description</span>
    //                 <span className="data">{impdes_roadblock}</span>
    //               </div>
    //             )}
    //             <div className="dataRow">
    //               <span className="name">Road damages</span>
    //               <span className="data"> {imp_roaddamage}</span>
    //             </div>
    //             {impdes_roaddamage && (
    //               <div className="dataRow">
    //                 <span className="name">More description</span>
    //                 <span className="data">{impdes_roaddamage}</span>
    //               </div>
    //             )}
    //             <div className="dataRow">
    //               <span className="name">Electricity supply failure</span>
    //               <span className="data">{imp_electricity}</span>
    //             </div>
    //             {impdes_electricity && (
    //               <div className="dataRow">
    //                 <span className="name">More description</span>
    //                 <span className="data">{impdes_electricity}</span>
    //               </div>
    //             )}
    //             <div className="dataRow">
    //               <span className="name">Water supply failure</span>
    //               <span className="data">{imp_water}</span>
    //             </div>
    //             {impdes_water && (
    //               <div className="dataRow">
    //                 <span className="name">More description</span>
    //                 <span className="data">{impdes_water}</span>
    //               </div>
    //             )}
    //             <div className="dataRow">
    //               <span className="name">Communication supply failure</span>
    //               <span className="data">{imp_communication}</span>
    //             </div>
    //             {impdes_communication && (
    //               <div className="dataRow">
    //                 <span className="name">More description</span>
    //                 <span className="data">{impdes_communication}</span>
    //               </div>
    //             )}
    //           </div>
    //         </div>
    //         <div className={"commentContainer no-drag"}>
    //           <span className="title">land slide balangoda</span>
    //           <PopUpWindowChat w_id={wId} />
    //         </div>
    //       </div>
    //       <div className={"detailsTabContainerRight no-drag"}>
    //         <ShowSlider img_url={imgUrl} w_id={wId} />
    //       </div>
    //     </div>
    //   </div>
    // </div>
    
  );
};
export default SumMainHz;